import styled from "styled-components";

export const CarouselContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;

  span{
    color: #252525;
    font-size: 12px;
  }
`;

export const CarouselWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: auto;
`;

export const ButtonCarousel = styled.button`
  cursor: pointer;
  border: none;
  background: transparent;
  display: flex;
  width: auto;
  padding: 6px;
  border-radius: 3px;

  &:hover {
    background-color: #E5F3FD;
  }

  ${({hasName}) => hasName && `
    margin-bottom: 18px;
  `}
`;

export const ImageWrapper = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  padding: 10px;
  width: 160px;
  height: 80px;
  overflow: hidden;
`;

export const Image = styled.img``;

export const OptionWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: ${(props) => props.height || 'auto'};
  padding: 0 15px;
  transform: translate(-150%, -50%);
  transition: transform 0.4s cubic-bezier(0.075,0.82,0.165,1);
  z-index: 1;

  &.active {
    transform: translate(-50%, -50%);
    z-index: 2;

    +div {
      transform: translate(+50%, -50%);
    }
  }

  ${({hasName}) => hasName && `
    height: 100%;
    justify-content: flex-start;
    gap: 6px;
  `}
`;

export const OptionName = styled.span`
  color: #878787;
`;

export const BulletsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 12px;

  input[type="radio"] {
    all: unset;
    margin: 0 5px;
    cursor: pointer;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: #D9D9D9;
    transition: all 0.8s cubic-bezier(0.075, 0.82, 0.165, 1);

    &:checked {
      background: #50AFF4;
      width: 11px;
      height: 11px;
    }
  }
`;
